module.exports = __webpack_public_path__ + "assets/img/1.1125cae8.jpg";